import React from 'react';
import {Link} from 'react-router-dom';
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Container from 'react-bootstrap/Container';
//images
import logoInovaria from '../../../assets/images/certifications/logo-inovaria.svg';
import logoMicrosoft from '../../../assets/images/certifications/logo-microsoft.svg';
import logo9001 from '../../../assets/images/certifications/logo-iso9001.svg';
import logo27001 from '../../../assets/images/certifications/logo-iso27001.svg';
import logo4457 from '../../../assets/images/certifications/logo-iso4457.svg';
import portugal from '../../../assets/images/certifications/logo-portugal-2020.svg';
import ue from '../../../assets/images/certifications/logo-uniao-europeia.svg';
import compete from '../../../assets/images/certifications/logo-compete-2020.png';
import pme from '../../../assets/images/certifications/logo-PME.svg';
//files
import pdf9001 from '../../../assets/files/SYS-MATCHE-5078.pdf';
import pdf27001 from '../../../assets/files/SYS-MATCHSI-0049.pdf';
import pdf4457 from '../../../assets/files/SYS-MATCHIDI-0079.pdf';


const certifications = props => (
    <section 
        id="homepage-section10"
        className="my"> 
        <Container>
            <Row>
                <Col xs="5" sm="5" md="3" className="pb-4">
                    <p>{props.t("homepage:section-9.txt1")}</p>
                    <Row className="d-flex align-items-center">
                        <Col xs md="6" className="pr-3">
                            <img src={logoInovaria} alt="Logo Inovaria"/>
                        </Col>
                        <Col xs md="6" className="px-3"> 
                            <img src={logoMicrosoft} alt="Logo Microsoft"/>
                        </Col>
                    </Row>
                </Col>
                <Col xs="7" sm="7" md="5" className="pb-4">
                    <p>{props.t("homepage:section-9.txt2")}</p>
                    <div className="d-flex" >
                        <Col className="px-2">
                            <img src={compete} alt="Compete 2020"/>
                        </Col>
                        <Col className="px-2">
                            <img src={portugal} alt="Portugal"/>
                        </Col>
                        <Col className="px-2">
                            <img src={ue} alt="UE"/>
                        </Col>
                    </div>                   
                </Col>
                <Col xs="6" sm="5" md="3" className="pb-4">
                    <p>{props.t("homepage:section-9.txt3")}</p>
                    <div className="d-flex">
                        <Col className="px-2">
                            <img src={pme} alt="PME Líder 2020"/>
                        </Col>
                        <Col  className="px-2">
                            <Link to={pdf9001} target="blank">
                                <img src={logo9001} alt="Empresa certificada ISO9001"/>
                            </Link>
                        </Col>
                        <Col  className="px-2">
                            <Link to={pdf27001} target="blank">
                                <img src={logo27001} alt="Empresa certificada ISO27001"/>
                            </Link>
                        </Col>
                        <Col  className="px-2">
                            <Link to={pdf4457} target="blank">
                                <img src={logo4457} alt="Empresa certificada ISO4457"/>
                            </Link>
                        </Col>
                    </div>
                </Col>
            </Row>
        </Container>
    </section>
)

export default certifications;
